import { useState } from 'react';
import { WorkspaceTabShippingBillingDTO } from 'domains/workspaceDetailDomain';
import workspaceDetailService from 'services/workspaceDetailService';
import { useMount } from 'ahooks';

const useJobCardTabShippingBilling = (id: number) => {
  const [data, setData] = useState<WorkspaceTabShippingBillingDTO>();
  const [loading, setLoading] = useState(false);
  useMount(async () => {
    setLoading(true);
    const res = await workspaceDetailService.getWorkspaceShippingBilling(id);
    setData(res);
    setLoading(false);
  });
  return {
    data,
    loading,
  };
};
export default useJobCardTabShippingBilling;
